export default __webpack_public_path__ + "static/media/baloons-helmet.1b2505ad.jpg";